import type { MonthlyShiftSlotData } from '../../domain/dailyShiftSlot';
import type {
  DailyShiftSlotRepository,
  MonthlyShiftSlotFilter,
} from './ports/DailyShiftSlotRepository';

export interface FetchMonthlyShiftSlotsInput {
  year: number;
  month: number;
}

export interface FetchMonthlyShiftSlotsOutput {
  data: MonthlyShiftSlotData;
}

/**
 * 月次シフト枠を取得するUseCase
 * @param repository DailyShiftSlotRepository リポジトリインスタンス
 * @param input FetchMonthlyShiftSlotsInput 取得条件（年月）
 * @returns Promise<FetchMonthlyShiftSlotsOutput> 取得結果
 */
export async function fetchMonthlyShiftSlots(
  repository: DailyShiftSlotRepository,
  input: FetchMonthlyShiftSlotsInput
): Promise<FetchMonthlyShiftSlotsOutput> {
  const filter: MonthlyShiftSlotFilter = {
    year: input.year,
    month: input.month,
  };

  const data = await repository.getByMonth(filter);

  return { data };
}
